import React from 'react';

import { Form, Select } from 'antd';
import { AVAILABLE_LANGS } from 'app-config';
import { useTranslation } from 'react-i18next';

import { useNotification } from 'segments/hooks/useNotification';

import { langTitles } from 'features/change-lang/utils/conts';

// import { useGetUserSettingsQuery, useUpdateUserSettingsMutation } from 'features/user/store/userApi';

type Props = {
  title?: boolean;
};

const LangSelector = ({ title }: Props) => {
  const { t, i18n } = useTranslation();
  // const { data: userSettingsData, } = useGetUserSettingsQuery();

  // const [updateUserSettings, {
  //   isSuccess: isUpdateSuccess,
  //   isError: isUpdateError,
  // }] = useUpdateUserSettingsMutation();

  useNotification({
    // isSuccess: isUpdateSuccess,
    successMessage: t('lang-changed', 'Язык успешно изменён'),
    // isError: isUpdateError,
  });

  const handleLangChange = (lang: string) => {
    if (lang !== i18n.resolvedLanguage) {
      i18n.changeLanguage(lang);

      // if (userSettingsData) {
      //   await updateUserSettings({
      //     ...userSettingsData,
      //     lang,
      //   });
      // }
    }
  };

  return (
    <Form layout="vertical">
      <Form.Item style={{margin:'0px'}} label={title && <b>{t('user.settings.lang', 'Язык')}</b>}>
        <Select
          onChange={handleLangChange}
          value={i18n.resolvedLanguage}
        >
          {AVAILABLE_LANGS.map((langItem) => (
            <Select.Option key={langItem} value={langItem}>
              {langTitles[langItem]}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
    </Form>
  );
};

export default LangSelector;
